/**
 * @generated SignedSource<<d08c06536d0a36b48927fb143db756ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionDetailsModal_contribution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListContribution_contribution"
    }
  ],
  "type": "Contribution",
  "abstractKey": null
};

node.hash = "10003682b96707a51b535c083e8d1322";

module.exports = node;
